import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>About Inifiy</h1>
          <p>Your trusted partner in quality products and exceptional service</p>
        </div>
      </div>

      <div className="about-container">
        <section className="mission-section">
          <div className="section-content">
            <h2>Our Mission</h2>
            <p>
              At Inifiy, we're passionate about connecting customers with high-quality products 
              from around the world. Our mission is to provide an exceptional shopping experience 
              with competitive prices, reliable shipping, and outstanding customer service.
            </p>
            <div className="mission-stats">
              <div className="stat-item">
                <div className="stat-number">10K+</div>
                <div className="stat-label">Happy Customers</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">500+</div>
                <div className="stat-label">Products</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support</div>
              </div>
            </div>
          </div>
        </section>

        <section className="story-section">
          <div className="section-content">
            <h2>Our Story</h2>
            <div className="story-grid">
              <div className="story-text">
                <p>
                  Founded in 2020, Inifiy started as a small family business with a big dream: 
                  to make quality products accessible to everyone. What began as a local store has 
                  grown into a trusted online marketplace serving customers worldwide.
                </p>
                <p>
                  We believe that everyone deserves access to innovative, high-quality products 
                  without breaking the bank. That's why we work directly with manufacturers and 
                  suppliers to bring you the best prices while maintaining exceptional quality standards.
                </p>
                <p>
                  Today, we're proud to offer thousands of products across multiple categories, 
                  from cutting-edge electronics to home essentials, all backed by our commitment 
                  to customer satisfaction.
                </p>
              </div>
              <div className="story-image">
                <div className="image-placeholder">🏢</div>
              </div>
            </div>
          </div>
        </section>

        <section className="values-section">
          <div className="section-content">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">🤝</div>
                <h3>Trust & Reliability</h3>
                <p>We build lasting relationships with our customers through transparency and consistent quality.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">💎</div>
                <h3>Quality First</h3>
                <p>Every product we offer meets our strict quality standards and customer expectations.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🚀</div>
                <h3>Innovation</h3>
                <p>We continuously seek out the latest products and technologies to enhance your lifestyle.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">❤️</div>
                <h3>Customer Focus</h3>
                <p>Your satisfaction is our top priority. We're here to help you find exactly what you need.</p>
              </div>
            </div>
          </div>
        </section>



        <section className="contact-section">
          <div className="section-content">
            <h2>Get in Touch</h2>
            <p>Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h4>Email</h4>
                  <p>hello@inifiy.com</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p>+44 7838 155473</p>
                  <p style={{fontSize: '0.9rem', opacity: 0.8, marginTop: '5px'}}>Mon-Fri: 9AM-6PM GMT</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Address</h4>
                  <p>1 Martlet grove<br />Ub5 6ES</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About; 